module.exports = __webpack_public_path__ + "static/ajax-loader-49688c4e0c4d35d9d17975960af97d5a.gif";